import React, { useState, useEffect } from 'react';
import { message } from 'antd';
import styled from 'styled-components';
import { 
  CheckIcon
} from '@heroicons/react/outline';
import { userService } from '../../services';
import {
  Button,
  Input,
  colors,
  typography,
  spacing,
} from '../../design-system';

interface OrganizationSectionProps {
  organizationName: string;
  teamMembersCount: number;
  onOrganizationUpdated: () => void;
}

const SectionTitle = styled.h3`
  margin: 0 0 ${spacing[2]};
  font-size: ${typography.fontSizes.sm};
  font-weight: ${typography.fontWeights.normal};
  color: ${colors.text.secondary};
`;

export const OrganizationSection: React.FC<OrganizationSectionProps> = ({
  organizationName,
  teamMembersCount,
  onOrganizationUpdated
}) => {
  const [newOrgName, setNewOrgName] = useState(organizationName);
  const [updating, setUpdating] = useState(false);

  // Ensure the input is initialized with the current organization name
  useEffect(() => {
    setNewOrgName(organizationName);
  }, [organizationName]);

  const handleUpdateOrganization = async () => {
    if (!newOrgName.trim()) {
      // message.error('Organization name cannot be empty');
      return;
    }

    setUpdating(true);
    try {
      await userService.updateOrganization(newOrgName.trim());
      // message.success('Organization updated successfully');
      onOrganizationUpdated();
    } catch (error: any) {
      console.error('Error updating organization:', error);
      const errorMessage = error?.response?.data?.error || error?.message || 'Failed to update organization';
      // message.error(errorMessage);
    } finally {
      setUpdating(false);
    }
  };

  return (
    <div>
      {/* Organization Settings */}
      <div>
        <SectionTitle>Organization Name</SectionTitle>
        
        <div style={{ display: 'flex', gap: spacing[2], alignItems: 'flex-end' }}>
          <div style={{ flex: 1 }}>
            <Input
              label=""
              value={newOrgName}
              onChange={(e) => setNewOrgName(e.target.value)}
              placeholder="Organization name"
              fullWidth
            />
          </div>

          <Button
            variant="ghost"
            size="sm"
            icon={<CheckIcon style={{ width: '12px', height: '12px' }} />}
            onClick={handleUpdateOrganization}
            loading={updating}
            disabled={newOrgName.trim() === organizationName || !newOrgName.trim()}
          >
            Save
          </Button>
        </div>
        
        <div style={{ 
          fontSize: typography.fontSizes.xs,
          color: colors.text.tertiary,
          marginTop: spacing[1]
        }}>
          This is your organization's display name across the platform.
        </div>
      </div>
    </div>
  );
};

export default OrganizationSection; 